/**
 * Story 8.12 — Onglet Bancaire en lecture seule (modale profil membre)
 * Affiche les coordonnées de contact et les infos bancaires.
 * IBAN masqué (seuls les 4 derniers caractères via masked_iban).
 * Pas de boutons d'édition.
 */
import React from 'react';
import type { ProfileData } from '../../../../../services/profileService';

interface ReadOnlyBancaireProps {
    data: ProfileData;
}

const ReadOnlyBancaire: React.FC<ReadOnlyBancaireProps> = ({ data }) => {
    const { coordonnees, bancaire } = data;

    return (
        <div className="readonly-tab readonly-bancaire">
            {/* Contact légal */}
            <section className="readonly-section">
                <div className="readonly-section-title">Contact légal (représentant)</div>
                <div className="readonly-grid three-cols">
                    <div className="readonly-field">
                        <label>Nom</label>
                        <p>{coordonnees?.legal_nom || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Prénom</label>
                        <p>{coordonnees?.legal_prenom || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Fonction</label>
                        <p>{coordonnees?.legal_fonction || '-'}</p>
                    </div>
                </div>
                <div className="readonly-grid two-cols">
                    <div className="readonly-field">
                        <label>Email</label>
                        <p>{coordonnees?.legal_email || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Téléphone</label>
                        <p>{coordonnees?.legal_tel || '-'}</p>
                    </div>
                </div>
            </section>

            {/* Contact comptabilité */}
            <section className="readonly-section">
                <div className="readonly-section-title">Contact comptabilité</div>
                <div className="readonly-grid three-cols">
                    <div className="readonly-field">
                        <label>Nom</label>
                        <p>{coordonnees?.compta_nom || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Prénom</label>
                        <p>{coordonnees?.compta_prenom || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Fonction</label>
                        <p>{coordonnees?.compta_fonction || '-'}</p>
                    </div>
                </div>
                <div className="readonly-grid two-cols">
                    <div className="readonly-field">
                        <label>Email</label>
                        <p>{coordonnees?.compta_email || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Téléphone</label>
                        <p>{coordonnees?.compta_tel || '-'}</p>
                    </div>
                </div>
            </section>

            {/* Contact facturation */}
            <section className="readonly-section">
                <div className="readonly-section-title">Contact facturation</div>
                <div className="readonly-grid three-cols">
                    <div className="readonly-field">
                        <label>Nom</label>
                        <p>{coordonnees?.facture_nom || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Prénom</label>
                        <p>{coordonnees?.facture_prenom || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Fonction</label>
                        <p>{coordonnees?.facture_fonction || '-'}</p>
                    </div>
                </div>
                <div className="readonly-grid two-cols">
                    <div className="readonly-field">
                        <label>Email</label>
                        <p>{coordonnees?.facture_email || '-'}</p>
                    </div>
                    <div className="readonly-field">
                        <label>Téléphone</label>
                        <p>{coordonnees?.facture_tel || '-'}</p>
                    </div>
                </div>
            </section>

            {/* Coordonnées bancaires */}
            <section className="readonly-section">
                <div className="readonly-section-title">Coordonnées bancaires</div>
                {!bancaire ? (
                    <p className="readonly-empty">Aucune coordonnée bancaire renseignée.</p>
                ) : (
                    <div className="readonly-grid two-cols">
                        <div className="readonly-field">
                            <label>Titulaire du compte</label>
                            <p>{bancaire.nom_titulaire || '-'}</p>
                        </div>
                        <div className="readonly-field">
                            <label>Banque</label>
                            <p>{bancaire.banque || '-'}</p>
                        </div>
                        <div className="readonly-field">
                            <label>IBAN</label>
                            <p className="readonly-iban-masked">{bancaire.masked_iban || '****'}</p>
                        </div>
                        <div className="readonly-field">
                            <label>BIC</label>
                            <p>{bancaire.BIC || '-'}</p>
                        </div>
                        <div className="readonly-field">
                            <label>N° TVA intracommunautaire</label>
                            <p>{bancaire.numero_tva || '-'}</p>
                        </div>
                    </div>
                )}
            </section>
        </div>
    );
};

export default ReadOnlyBancaire;
